// extracted by mini-css-extract-plugin
module.exports = {"TabSwriper1":"TabSwriper1_TabSwriper1__2xmbT"};